import { useEffect, useState } from 'react';
import { getFormulas } from '../services/api';
import { Formula } from '../pages/Offerte/types';

// Submissions stored before formulas moved to the database used these ids
const LEGACY_FORMULA_SLUGS: Record<string, string> = {
  optie1: 'classic',
  optie2: 'mini-burger-festival',
};

export const useFormulas = () => {
  const [formulas, setFormulas] = useState<Formula[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getFormulas()
      .then((data) => {
        if (!cancelled) setFormulas(data);
      })
      .catch(() => {
        if (!cancelled) setError('De formules konden niet geladen worden. Probeer later opnieuw.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { formulas, loading, error };
};

// Maps a stored or linked formula value to a slug that exists, falling back to the highlighted formula
export const resolveFormulaSlug = (value: string | null | undefined, formulas: Formula[]): string => {
  const slug = value ? LEGACY_FORMULA_SLUGS[value] ?? value : '';
  if (formulas.some((formula) => formula.slug === slug)) return slug;
  return (formulas.find((formula) => formula.highlighted) ?? formulas[0])?.slug ?? '';
};
